export default {
    email: 'Email',
    sms: 'SMS'
};
